import { Flex } from "@chakra-ui/react";
import { ReactElement } from "react";
import { DisplayFlags, LayoutStyle } from "../../../types";
import { useGridCardDimensions } from "../hooks/useGridCardDimensions";
import { useMobileBreakpoint } from "../../../utils/useBreakpoints";

export function GridCardWrapper({
  children,
  layout: {
    style: { context, mode, size },
  },
  fullWidth = false,
  fullHeight = false,
  hideBackdrop = false,
  noPointer,
}: {
  layout: {
    style: LayoutStyle;
    display: DisplayFlags;
  };
  children: ReactElement | ReactElement[];
  fullWidth?: boolean;
  fullHeight?: boolean;
  hideBackdrop?: boolean;
  noPointer?: boolean;
}) {
  const { width, height } = useGridCardDimensions(context, mode, size);
  const isMobile = useMobileBreakpoint();

  const isV2 = size === "v2";
  const isSmallCard = size === "m";
  const useFluidWidth = fullWidth || isV2;
  return (
    <Flex
      maxHeight={fullHeight || isV2 ? undefined : `${height}px`}
      width={useFluidWidth ? "100%" : `${width}px`}
      maxW={useFluidWidth ? "100%" : `${width}px`}
      direction="column"
      position="relative"
      alignItems={isV2 ? "stretch" : "center"}
      justifyContent={isV2 ? "flex-start" : "center"}
      cursor={noPointer ? "default" : "pointer"}
      px={
        hideBackdrop || isV2
          ? undefined
          : isSmallCard
            ? ".5rem"
            : mode === "grid"
              ? "1rem"
              : ".75rem"
      }
      gap=".5rem"
      _hover={
        isV2
          ? {
              "&>.card-img-wrapper": {
                opacity: 0.8,
              },
            }
          : {
              "&>.card-img-wrapper": {
                mt: 0,
                mb: isMobile ? "0px" : "4px",
              },
            }
      }
      sx={{
        "&>.card-img-wrapper": {
          position: "relative",
          mt: isMobile || isV2 ? "0px" : "4px",
          mb: 0,
          transition: isV2 ? "opacity 0.2s ease" : "all .2s linear",
          borderRadius: isV2 ? "8px" : undefined,
          width: "100%",
          height: "auto",
        },
      }}
    >
      {children}
    </Flex>
  );
}
